import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { activateOnboardingStep, setOnboardingAnswers } from 'actions/assessment'
import { RangeSlider } from '../Assessment/RangeSlider'
import '../Assessment/styles.scss'

const Satisfaction = () => {
    const dispatch = useDispatch()

    const {
        appState: {
            onboardingAnswers: { assessment },
        },
        database: {
            onboardingTemplate: { assessmentList, index },
        },
    } = useSelector(state => state.assessment)

    const [pillars, setPillars] = useState([
        {
            Sleep: { value: null, tags: [] },
            Exercise: { value: null, tags: [] },
            Nutrition: { value: null, tags: [] },
            Community: { value: null, tags: [] },
            StressManagement: { value: null, tags: [] },
            MeaningfulActivity: { value: null, tags: [] },
            LifeSatisfaction: { value: null, tags: [] },
            PositiveEmployer: { value: null, tags: [] },
        },
    ])

    useEffect(() => {
        if (assessment.length > 0) {
            setPillars(assessment)
        }
    }, [index])

    useEffect(() => {
        const values = Object.values(pillars[0])
            .map(el => el.value)
            .filter(el => el !== null)
        if (values.length === 8) {
            dispatch(setOnboardingAnswers(pillars, 'assessment'))
            dispatch(activateOnboardingStep({ number: 8, state: false }))
        }
    }, [pillars])

    const onChange = (pillar, val) => {
        const pillarSelected = pillars[0][pillar]
        setPillars([{ ...pillars[0], [pillar]: { ...pillarSelected, value: val[0] } }])
    }
    return (
        <div className="assessmentContainer">
            {assessmentList.slice(6).map((item, id) => (
                <div style={{ margin: '16px 8px 32px' }} key={id}>
                    <p
                        style={{
                            fontWeight: '700',
                            paddingBottom: 12,
                        }}
                    >
                        {item.question.text}
                    </p>
                    <RangeSlider
                        onChange={onChange}
                        assessmentList={assessmentList}
                        index={id}
                        values={[pillars[0][item.label].value]}
                        colour={item.colour}
                        ariaLabelledby={item.label}
                        onboarding={true}
                    />
                </div>
            ))}
        </div>
    )
}

export default Satisfaction
